<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
    export default {
        name: 'App',
        mounted () {
          const xyOriginBool = this.$store.state.user.xyOriginBool
          const yxyOriginBool = this.$store.state.user.yxyOriginBool
          if (xyOriginBool || yxyOriginBool) {
            this.changeFavicon(xyOriginBool, yxyOriginBool)
          }
        },
        methods: {
          changeFavicon (xyOriginBool, yxyOriginBool) {
            let favicon = document.querySelector('link[rel="icon"]')
            // console.log('app', favicon)
            if (favicon !== null) {
              if (xyOriginBool) {
                favicon.href = '/faviconxy.ico'
                // console.log(favicon.href)
              }
              if (yxyOriginBool) {
                favicon.href = '/favicongd.ico'
                // console.log(favicon.href)
              }
            } else {
              favicon = document.createElement('link')
              favicon.rel = 'icon'
              if (xyOriginBool) {
                favicon.href = '/faviconxy.ico'
              }
              if (yxyOriginBool) {
                favicon.href = '/favicongd.ico'
              }
              document.head.appendChild(favicon)
            }
          }
        }
    }
</script>
<style lang="less">
  html {
    height: 100%;
    margin: 0;
    padding: 0;
    border: none;
  }

  a {
    color: #000000;
  }

  body {
    position: relative;
    box-sizing: border-box;
    margin: 0;
    // height: 100%;
    font-size: 16px;
    // background-color: #5a6ef9;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
  }

  .bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 500px;
    background-color: #FFC107;
    z-index: -1;
  }

  .viplist {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow: scroll;
    padding: 0 0 10px 0;
  }

  .name {
    font-size: 16px;
  }

  .trueAmount {
    font-size: 24px;
    margin: 20px 0;
    font-weight: bold;
  }

  .intro {
    font-size: 12px;
  }

  .product {
    width: 110px;
    border: 2px solid #ff9900;
    border-radius: 8px;
    font-size: 14px;
    margin: 5px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding: 0 0 10px;

  }

  .bottom-bg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 500px;
    background-color: #FFC107;
    z-index: -1;
  }



  .title {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    .van-icon {
      margin: 0 10px;
    }
  }

  .image {
    width: 100%;
    // height: 180px;
  }

  .avatar {
    width: 72px;
    height: 72px;
    border-radius: 36px;

  }

  .title2 {
    justify-content: flex-start;
    border-bottom: 1px solid #f7f7f7;
    margin-bottom: 10px;
  }

  .panel {
    margin: 16px;
    border-radius: 10px;
    padding: 10px;
    background-color: #ffffff;
    box-shadow: #00000023 0 4px 12px;
    overflow: hidden;
  }
   .panel1 {
    margin:16px 8px;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: #00000023 0 4px 12px;
    overflow: hidden;
  }

  .van-col {
    display: flex;
    align-content: center;

    &:last-child {
      justify-content: flex-end;
    }

    &:first-child {
      justify-content: flex-start;
    }
  }

  .popup {
    width: 350px;
    padding: 10px 0;
    border-radius: 10px;
    font-size: 16px;
  }
</style>